<div class="login-component">
  <div class="header-content">
    <div class="header-left">
      <img class="main-logo" height="30px" src="assets/images/Logo_proeconomy-transparent.svg" alt="Pro Economy">
      <div class="flex-center-content">
        <h2 class="app-title">TETRAS</h2>
      </div>
    </div>
  </div>

  <div class="main-content-wrapper">
    <div class="center-content">
      <div class="login-card">
        <div class="login-card-header">
          <p class="login-subtitle">Sign in to continue to TETRAS</p>
        </div>

        <form [formGroup]="loginForm" class="login-form">
          <div class="form-field-container">
            <mat-form-field class="login-form-field" appearance="fill">
              <mat-label>Email Address</mat-label>
              <input matInput formControlName="username" type="email"/>
            </mat-form-field>
            @if (loginForm.get('username')?.touched && loginForm.get('username')?.invalid) {
              <div class="validation-error">
                @if (loginForm.get('username')?.errors?.['required']) {
                  <div>Email Address is required</div>
                }
              </div>
            }
          </div>

          <div class="form-field-container">
            <mat-form-field class="login-form-field" appearance="fill">
              <mat-label>Password</mat-label>
              <input matInput formControlName="password" type="password"/>
            </mat-form-field>
            @if (loginForm.get('password')?.touched && loginForm.get('password')?.invalid) {
              <div class="validation-error">
                @if (loginForm.get('password')?.errors?.['required']) {
                  <div>Password is required</div>
                }
              </div>
            }
          </div>

          <div class="button-container">
            <button type="button" mat-raised-button color="primary" class="login-btn" (click)="submitClicked()">
              Sign In
            </button>
            <button type="button" mat-button class="reset-btn" (click)="resetClicked()">
              Reset Password
            </button>
          </div>

          @for (err of errorMessages; track err) {
            <div class="error-container">
              <span class="validation-error">{{ err }}</span>
            </div>
          }
        </form>
      </div>
    </div>
  </div>
</div>